module.exports = __webpack_public_path__ + "img/income.57c670d3.png";